import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ApplicationStatus } from "../enums/applicationStatus";

const statuses: ApplicationStatus[] = [
  ApplicationStatus.WAITING_FOR_ADMIN_APPROVAL,
  ApplicationStatus.ADMIN_REJECTED,
  ApplicationStatus.COMPANY_APPROVED,
  ApplicationStatus.COMPANY_REJECTED,
  ApplicationStatus.COMPANY_CANCELLED,
  ApplicationStatus.STUDENT_CANCELLED,
  ApplicationStatus.SCHOOL_CANCELLED,
  ApplicationStatus.WAITING_FOR_SCHOOL_APPROVAL,
  ApplicationStatus.WAITING_FOR_COMPANY_APPROVAL,
];

const useApplicationStatuses = () => {
  const { t } = useTranslation();

  const labels = useMemo<Record<ApplicationStatus, string>>(
    () => ({
      [ApplicationStatus.WAITING_FOR_ADMIN_APPROVAL]: t("applications.status.WaitingForAdminApproval"),
      [ApplicationStatus.ADMIN_REJECTED]: t("applications.status.AdminRejected"),
      [ApplicationStatus.COMPANY_APPROVED]: t("applications.status.CompanyApproved"),
      [ApplicationStatus.COMPANY_REJECTED]: t("applications.status.CompanyRejected"),
      [ApplicationStatus.COMPANY_CANCELLED]: t("applications.status.CompanyCancelled"),
      [ApplicationStatus.STUDENT_CANCELLED]: t("applications.status.StudentCancelled"),
      [ApplicationStatus.SCHOOL_CANCELLED]: t("applications.status.SchoolCancelled"),
      [ApplicationStatus.WAITING_FOR_SCHOOL_APPROVAL]: t("applications.status.WaitingForSchoolApproval"),
      [ApplicationStatus.WAITING_FOR_COMPANY_APPROVAL]: t("applications.status.WaitingForCompanyApproval"),
    }),
    [t]
  );

  return useMemo(
    () => ({
      statuses,
      statusOptions: statuses.map((status) => ({
        key: status,
        value: status,
        text: labels[status],
      })),
    }),
    [labels]
  );
};

export default useApplicationStatuses;
